import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7srg6ubmfn: FaireBrandEntity = {
  token: "b_7srg6ubmfn",
  type: "brand",
  name: "Cook's Bay Candle Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/666761cb6a4bec514185a5fbe225220947b47914df4f7ce5ba17faaaee75487e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ce6f99bb9298202d2d5567d54f34765ba6b89545172e74024d2f7a5b6dfd39cd.png",
  logoUrl:
    "https://cdn.faire.com/fastly/666761cb6a4bec514185a5fbe225220947b47914df4f7ce5ba17faaaee75487e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ce6f99bb9298202d2d5567d54f34765ba6b89545172e74024d2f7a5b6dfd39cd.png",
  location: "Innisfil, ON, CAN",
  minimumOrderDollars: 140,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "Cook's Bay Candle Co. started with a simple, stubborn urge: to make something beautiful by hand. Out of a small family studio — and an artistic family with design in its heart — that urge became hand-poured taper candles and candle objects, made a few dozen at a time on the shores of Cook's Bay, at the southern edge of Lake Simcoe.\n\nEvery piece is hand-dyed and hand-poured from custom blends of natural soy and beeswax. The tapers melt from one shade into the next, the spirals and ridges catch the light along their edges, and the colours are mixed by hand — found on no one else's shelf. There's no added fragrance, by design: just clean wax and considered colour, so a candle can sit in a room without ever competing with it.\n\nThe name holds two shorelines. The studio looks out over Cook's Bay here on Lake Simcoe, while the coral in our mark belongs to another Cook's shore entirely — the reefs off Kona, Hawaii, and years spent in that clear, bright water. Two coasts, one family, both pressed into the label.\n\nWhat guides the work is uncomplicated: beauty, craftsmanship, and the small details that make an object feel considered rather than made by the thousand. A Cook's Bay candle is the piece guests notice on the table — and the gift you'd almost rather keep.\n\nSmall batch. Hand poured. Made in Innisfil, Ontario.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:07.674Z",
    importedBy: "entity-db-cli",
  },
};
